import { Close } from '@mui/icons-material';
import { Avatar, Box, Dialog, DialogContent, DialogTitle, Grid, IconButton, Typography } from '@mui/material';
import React from 'react';

interface Props {
    open: boolean;
    currentImage: string;
    images: string[];
    onClose: () => void;
    onSelectImage: (image: string) => void;
    getAvatarUrl: (image: string) => string | undefined;
}

const ProfileImageSelector: React.FC<Props> = ({ 
    open, 
    currentImage, 
    images, 
    onClose, 
    onSelectImage,
    getAvatarUrl 
}) => {
    const handleImageClick = (image: string): void => {
        onSelectImage(image);
        onClose();
    };

    return (
        <Dialog 
            open={open} 
            onClose={onClose}
            maxWidth="sm"
            fullWidth
            PaperProps={{
                sx: {
                    borderRadius: '16px',
                    backgroundColor: '#313131',
                    border: '1px solid rgba(255, 215, 0, 0.18)',
                }
            }}
        >
            <DialogTitle sx={{ 
                display: 'flex', 
                justifyContent: 'space-between', 
                alignItems: 'center',
                pb: 1
            }}>
                <Typography variant="h6">Wähl dei Profilbuidl</Typography>
                <IconButton 
                    onClick={onClose}
                    size="small"
                    aria-label="close"
                >
                    <Close />
                </IconButton>
            </DialogTitle>
            <DialogContent sx={{ pt: 1 }}>
                <Grid container spacing={2}>
                    {images.map((image, index) => (
                        <Grid item xs={4} sm={3} key={`image-${index}`}>
                            <Box
                                onClick={() => handleImageClick(image)}
                                sx={{
                                    cursor: 'pointer',
                                    position: 'relative',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    transition: 'transform 0.2s, box-shadow 0.2s',
                                    '&:hover': {
                                        transform: 'scale(1.05)',
                                    },
                                    '&:active': {
                                        transform: 'scale(0.95)',
                                    }
                                }}
                            >
                                <Avatar
                                    src={getAvatarUrl(image)}
                                    alt={`Profile option ${index + 1}`}
                                    sx={{
                                        width: { xs: 64, sm: 80 },
                                        height: { xs: 64, sm: 80 },
                                        border: currentImage === image 
                                            ? '3px solid #FFD700' 
                                            : '2px solid transparent',
                                        boxShadow: currentImage === image 
                                            ? '0 0 12px rgba(255, 215, 0, 0.6)' 
                                            : 'none',
                                    }}
                                />
                            </Box>
                        </Grid>
                    ))}
                </Grid>
            </DialogContent>
        </Dialog>
    );
};

export default ProfileImageSelector;
